import { render, staticRenderFns } from "./ShipmentCertificateWrapper.vue?vue&type=template&id=1a27b1ea&scoped=true&"
import script from "./ShipmentCertificateWrapper.vue?vue&type=script&lang=ts&"
export * from "./ShipmentCertificateWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27b1ea",
  null
  
)

export default component.exports